import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import TokenService from '../services/TokenStorage';
import { onResponseError } from './responseErrorInterceptor';
import { authenticateToken } from '../helpers/security-helper';
import { InsightService } from '@pepper/insights-react';

if (process.env.REACT_APP_INSIGHTS_INSTRUMENTACION_KEY) {
  InsightService.initInsights(process.env.REACT_APP_INSIGHTS_INSTRUMENTACION_KEY);
}

const onRequest = async (config: AxiosRequestConfig) => {
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);

  const accessToken = getParamToken(urlParams);

  if (config.headers && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${String(accessToken)}`;
  }
  return config;
};

const getParamToken = async (
  urlParams: URLSearchParams
): Promise<string | null> => {
  let token;
  if (urlParams.get('token') && !TokenService.getToken()) {
    token = urlParams.get('token');
    if (token) {
      const accessToken = await authenticateToken(token);
      if (accessToken) {
        TokenService.setToken(accessToken);
        token = accessToken;
      }
    }
  } else {
    token = TokenService.getToken();
  }
  return token;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  InsightService.logEvent('Request', [
    {
      request: {
        requestURL: response.request?.responseURL,
        config: response.config,
      },
    },
    { response: response.data },
  ]);
  return response.data;
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance
): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
